import { GenericType } from "@/types";
import { useEffect } from "react";
import Xarrow from "react-xarrows";

export function LeaderLine({ ref1, ref2, y }: GenericType) {
  useEffect(() => {
    console.log({ y });
  }, [y]);
  return (
    <>
      {ref1 && ref2 ? (
        <Xarrow
          start={ref1}
          end={ref2}
          color="#5fdaa1"
          headColor="#09c76c"
          strokeWidth={2}
          headSize={7}
          path="grid"
          showXarrow={true}
          showTail={true}
          tailShape="circle"
          dashness={{ strokeLen: 7, nonStrokeLen: 3 }}
          zIndex={0}
        />
      ) : null}
    </>
  );
}
